import { Box, styled } from "@mui/material";

export const LeftPanelContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$width",
})<{ $width: number }>(({ theme, $width }) => ({
  position: "fixed",
  left: 0,
  top: "calc(var(--bannerHeight, 0px) + var(--topNavigationHeight, 0px))",
  bottom: 0,
  width: $width,
  zIndex: 300,
  backgroundColor: theme.palette.background.paper,
  overflow: "auto",
}));
